import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { ScreenFeedbackRouteModule } from '@kp/screen-feedback/screen-feedback-routing.module';
import { SharedModule } from '@kp/shared/shared.module';

@NgModule({
  declarations: [ScreenFeedbackRouteModule.components],
  imports: [CommonModule, ScreenFeedbackRouteModule, ReactiveFormsModule, SharedModule],
})
export class ScreenFeedbackModule {}
